import request from '@/utils/request'
import Vue from 'vue'


// 业务咨询合作(传分页参数返回分页，不传返回列表)
export function getConsultingCooperation(data) {
    return request({
        method: 'POST',
        url: Vue.prototype.baseURL + '/product/professional-information/getConsultingCooperation',
        data
    })
}


// 农资采集(传分页参数返回分页，不传返回列表)
export function getTeaPurchase(data) {
    return request({
        method: 'POST',
        url: Vue.prototype.baseURL + '/product/professional-information/getTeaPurchase',
        data
    })
}


// 农资采集--详情
export function teaPurchaseDetail(params) {
    return request({
        method: 'POST',
        url: Vue.prototype.baseURL + '/product/professional-information/teaPurchaseDetail',
        params
    })
}
//茶叶预定提交
export function submitSchedule(data) {
    return request({
        method: 'POST',
        url: Vue.prototype.baseURL + '/fsCommodity/fs-commodity-customer/insert',
        data
    })
}


//检测信息列表--point
export function getMapPointData(params) {
    return request({
        method: 'POST',
        url: Vue.prototype.baseURL +'/services/material-promotion-api/getMaterialPromotionPage',
        params
    })
}

